import { api } from './api';

export interface NotificationDto {
  id: number;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsListResponse {
  items: NotificationDto[];
  unreadCount: number;
}

export const notificationsService = {
  async list(): Promise<NotificationsListResponse> {
    const { data } = await api.get<NotificationsListResponse>('/notifications');
    return data;
  },
  async markRead(id: number): Promise<void> {
    await api.post(`/notifications/${id}/read`);
  },
  async markAllRead(): Promise<void> {
    await api.post('/notifications/read-all');
  },
};
